/**
 * This function builds the filter that should be attached to the end of certain requests,
 * given a certain number of parameters that may or may not be set
 *
 * @params request - Object that contains page number and the keys that specify the order of the items
 * @params props   - String that speifies any additional filters that should be added
 */
export function getFilter (request, props) {
  let filters = ''
  for (const key in request) {
    const value = request[key]
    if (value) {
      if (filters.length) {
        filters += '&'
      }
      if (Array.isArray(value)) {
        for (const [index, val] of value.entries()) {
          let amp = index + 1 < value.length ? '&' : ''
          filters += `${key}=${val}${amp}`
        }
      } else {
        filters += `${key}=${value}`
      }
    }
  }
  let more = props ? `&${props}` : ''
  return (filters || more) && `?${filters}${more}`
}

/**
 * This funciton looks through a list of items and finds and returns the first one with a particular id
 *
 * @params stateArr - Array of objects that specify state items
 * @params itemId   - The id of the item that is being looked for
 */
export function findItem (stateArr, itemId) {
  return stateArr.filter(item => {
    return item.id === parseInt(itemId)
  })[0]
}

/**
 * This funciton takes a Xls response and automagically downloads it
 *
 * @params response - the Xls Response
 * @params name - the name the file should be saved with
 */
export function downloadXlsFromResponse (response, name) {
  const url = URL.createObjectURL(new Blob([response.data], {
        type: 'application/vnd.ms-excel'
      }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', name)
      document.body.appendChild(link)
      link.click()
}
